module.exports = __webpack_public_path__ + "img/016-hedgehog.e7f05d4f.svg";